import supabase from './lib/supabase';

const PROXY_URL = process.env.REACT_APP_SUPABASE_URL + '/functions/v1/claude-proxy';

function getLang() {
  return localStorage.getItem('gedready-lang') || 'en';
}

async function callProxy(type, payload = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not logged in.');

  const res = await fetch(PROXY_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ type, payload, lang: getLang() }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data.result;
}

function extractJSON(text) {
  const fenced = text.match(/```(?:json)?\s*([\s\S]*?)\s*```/);
  if (fenced) return JSON.parse(fenced[1].trim());
  const block = text.match(/\{[\s\S]*\}/);
  if (block) return JSON.parse(block[0]);
  return JSON.parse(text.trim());
}

function buildVarianceHint(subject, topic) {
  const pick = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const units = ['cm', 'm', 'ft', 'in', 'yd'][pick(0, 4)];
  const d = () => pick(3, 23);

  if (subject === 'Math' && topic === 'Geometry') {
    const concepts = [
      'area of a triangle', 'perimeter of a rectangle', 'area of a circle',
      'Pythagorean theorem', 'area of a parallelogram', 'circumference of a circle',
      'volume of a rectangular prism', 'surface area of a box',
    ];
    const concept = concepts[pick(0, concepts.length - 1)];
    return `Required concept: ${concept}. You MUST use these exact measurements in the question: ${d()} ${units} and ${d()} ${units}. Do not use 3-4-5 or any other standard textbook example.`;
  }
  if (subject === 'Math') {
    return `You MUST use these specific numbers in the question: ${d()}, ${d()}, and ${d()}. Build a fresh real-world scenario around them.`;
  }
  return '';
}

export async function generateQuestion(subject, topic, recentQuestions = []) {
  const varianceHint = buildVarianceHint(subject, topic);
  const text = await callProxy('question', { subject, topic, recentQuestions: recentQuestions.slice(-3), varianceHint });
  const q = extractJSON(text);
  const seen = new Set();
  q.options = q.options.map((opt, i) => {
    const key = opt.trim().toLowerCase();
    if (seen.has(key)) return `(different answer ${['A','B','C','D'][i]})`;
    seen.add(key);
    return opt;
  });
  return q;
}

export async function generateEssayPrompt() {
  const text = await callProxy('essay_prompt');
  return extractJSON(text);
}

export async function gradeEssay(essayPrompt, essay) {
  const text = await callProxy('grade_essay', { essayPrompt, essay });
  return extractJSON(text);
}

export async function askTutor(messages, context = '') {
  return callProxy('tutor', { messages, context });
}
